import React, { Component } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import ComingSoon from '../components/ComingSoon';
import api from '../services/api';
import LoadingSpinner from '../components/LoadingSpinner';

class JobDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      job: null,
      loading: true,
    };
  }

  async componentDidMount() {
    await this.fetchJob();
  }

  fetchJob = async () => {
    try {
      const { jobId } = this.props.params;
      const response = await api.get(`/jobs/${jobId}`);
      this.setState({ job: response.data.job, loading: false });
    } catch (error) {
      console.error('Failed to fetch job:', error);
      this.setState({ loading: false });
    }
  };

  handleBack = () => {
    this.props.navigate('/jobs');
  };

  render() {
    const { job, loading } = this.state;

    if (loading) {
      return (
        <div className="min-h-screen bg-slate-50">
          <Navbar />
          <div className="flex items-center justify-center h-96">
            <LoadingSpinner size="large" />
          </div>
        </div>
      );
    }

    if (!job) {
      return (
        <div className="min-h-screen bg-slate-50">
          <Navbar />
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-12 text-center">
              <svg className="w-16 h-16 text-slate-300 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <h2 className="text-2xl font-bold text-slate-900 mb-2">Job Not Found</h2>
              <p className="text-slate-600 mb-6">This job doesn't exist or you don't have access to it.</p>
              <button
                onClick={this.handleBack}
                className="btn-primary"
              >
                Back to Jobs
              </button>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="min-h-screen bg-slate-50">
        <Navbar />

        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {/* Header */}
          <div className="mb-8">
            <button
              onClick={this.handleBack}
              className="flex items-center text-slate-600 hover:text-slate-900 mb-4 transition"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
              Back to Jobs
            </button>
            
            <div className="flex items-center justify-between">
              <div>
                <h1 className="text-3xl font-bold text-slate-900">{job.name}</h1>
                <div className="flex items-center space-x-4 mt-2 text-sm text-slate-600">
                  <span>Owner: {job.ownerName}</span>
                  <span>•</span>
                  <span>Created: {new Date(job.createdAt).toLocaleDateString()}</span>
                  {job.archived && (
                    <>
                      <span>•</span>
                      <span className="px-2 py-0.5 text-xs font-medium rounded-full bg-yellow-100 text-yellow-800">
                        Archived
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Coming Soon Content */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200">
            <ComingSoon 
              title="Job Details Coming Soon"
              description="We're building a comprehensive job detail view with documents, timelines, collaborators, comments, and more."
              icon="job"
            />
          </div>
        </main>
      </div>
    );
  }
}

// Wrapper to use React Router hooks
const JobDetailWithRouter = (props) => {
  const params = useParams();
  const navigate = useNavigate();
  return <JobDetail {...props} params={params} navigate={navigate} />;
};

export default JobDetailWithRouter;